// extracted by mini-css-extract-plugin
module.exports = {"ImageCarousel":"styles_ImageCarousel__suJkG","headerContainer":"styles_headerContainer__RseOu","title":"styles_title__kGuNF","image":"styles_image__lFEPe"};